import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import {
  ICreditTransaction,
  ICreateCreditTransactionPayload,
} from "../types/creditTransaction";

const API = process.env.REACT_APP_API;

const useCreateCreditTransaction = () => {
  const fetch = useFetch();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: ICreateCreditTransactionPayload) => {
      return fetch(`${API}/api/semeadora/credit-transactions/`, {
        method: "POST",
        body: payload,
      }) as Promise<ICreditTransaction>;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["credit-transactions"]);
        queryClient.invalidateQueries(["urban-partners"]);
      },
    },
  );
};

export default useCreateCreditTransaction;
